import { useTranslation } from 'react-i18next';
import BllinkUtils from '../../../common/utils/utils';
import { calcMonthsTextForSelectBox, shortenText } from '../../../common/shared/statelessMethods';

const MonthlyReportsPdfRow = ({ row }) => {
    const { t } = useTranslation();

    const parseAmount = amountString => {
        if (amountString) {
            return <span>{BllinkUtils.Strings.numberWithCommas(amountString)}</span>
        }
    }

    const text = row.months ? calcMonthsTextForSelectBox(row.months) : shortenText(row.oneTime?.description);

    return (
        <div className='pdf-row'>
            <div className='monthly-report'>{row.ApartmentNumber}</div>
            <div className='monthly-report'>{row.ClientName}</div>
            <div className='monthly-report'>{parseAmount(row.Amount)}</div>
            <div className='monthly-report'>{BllinkUtils.BllinkTime.parseDate(row.PaymentDate)}</div>
            <div className='monthly-report'>{row.TenantType ? t(`reports.${row.TenantType}`) : ''}</div>
            <div className='monthly-report'>{text?.shortComment || text}</div>
            <div className='monthly-report'>{row.Comment}</div>
            <div className='monthly-report'>{row.paymentID}</div>
            <div className='monthly-report'>{row.translatedMethod}</div>
            <div className='monthly-report'>{row.CreatedBy}</div>
        </div>
    )
}

export default MonthlyReportsPdfRow;
